import '@fontsource/fredoka/latin-500.css';
import '@fontsource/fredoka/latin-600.css';
import '@fontsource/fredoka/latin-700.css';
import '@fontsource/nunito/latin-400.css';
import '@fontsource/nunito/latin-600.css';
import '@fontsource/nunito/latin-700.css';
import '@fontsource/nunito/latin-800.css';
import '@fontsource/nunito/latin-900.css';
import './styles/tokens.css';
import './styles/base.css';
import './styles/screens.css';
import './styles/quiz.css';
import './styles/bacaan.css';
import './styles/visuals.css';
import './styles/result.css';
import './styles/overlay.css';
import './styles/belajar.css';
import './styles/belajar-bilangan.css';
import './styles/belajar-geometri.css';
import './styles/belajar-data.css';
import './styles/belajar-bahasa.css';
import './styles/game.css';
import './styles/hp.css';

import { $ } from './core/dom.js';
import { closeModal, modalTerbuka } from './app/modal.js';
import { initBeranda } from './app/beranda.js';
import { initKuis } from './app/kuis.js';
import { initPWA } from './app/pwa.js';
import { initKeyboard } from './app/keyboard.js';
import { catatKunjungan } from './app/kunjungan.js';
import { pasangPerbesarGambar } from './app/jawaban.js';

document.addEventListener('keydown', e => { if (e.key === 'Escape' && modalTerbuka()) closeModal(); });
window.addEventListener('online', () => { const p = $('#offline-pill'); if (p) p.hidden = true; });
window.addEventListener('offline', () => { const p = $('#offline-pill'); if (p) p.hidden = false; });

// Versi demo satu file tidak punya halaman /tentang/.
if (typeof __DEMO__ !== 'undefined' && __DEMO__) document.querySelectorAll('.tentang-link').forEach(a => a.remove());

initPWA();
pasangPerbesarGambar();
initKeyboard();
initKuis();
initBeranda();
catatKunjungan();
